import React from 'react';
import { formatDistanceToNow, format } from 'date-fns';

interface DateCellProps {
  timestamp: number;
  blackMode?: boolean;
}

const DateCell: React.FC<DateCellProps> = ({ timestamp, blackMode = false }) => {
  const date = new Date(timestamp * 1000);

  // Calcular tiempo relativo
  const timeAgo = formatDistanceToNow(date, { addSuffix: true });
  
  // Formatear fecha específica
  const formattedDate = format(date, "MMM. do, HH:mm:ss");
  
  // Obtener timezone local
  const timezoneOffset = date.getTimezoneOffset();
  const timezoneHours = Math.abs(Math.floor(timezoneOffset / 60));
  const timezoneMinutes = Math.abs(timezoneOffset % 60);
  const timezoneSign = timezoneOffset > 0 ? '-' : '+';
  const timezoneString = `(GMT ${timezoneSign}${timezoneHours.toString().padStart(2, '0')}:${timezoneMinutes.toString().padStart(2, '0')})`;

  const textColorClass = blackMode ? 'text-black' : 'text-gray-900';
  const secondaryTextColorClass = blackMode ? 'text-violet-400' : 'text-gray-400';

  return (
    <div className={`text-sm ${textColorClass}`}>
      <div className={`text-xs ${secondaryTextColorClass}`}>{formattedDate} {timezoneString}</div>
      <div>{timeAgo}</div>
    </div>
  );
};

export default DateCell;